'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class;

var _reactRedux = require('react-redux');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _AddressListInput = require('components/AddressListInput/AddressListInput');

var _AddressListInput2 = _interopRequireDefault(_AddressListInput);

var _addresses = require('redux/actions/addresses');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AddressList: {
        displayName: 'AddressList'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/AddressList/index.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AddressList = _wrapComponent('AddressList')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
    promise: function promise(_ref) {
        var params = _ref.params,
            location = _ref.location,
            _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        return dispatch((0, _addresses.loadAddresses)());
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return {
        addresses: state.address.list,
        lang: state.lang
    };
}, {
    addAddress: _addresses.addAddress,
    updateAddress: _addresses.updateAddress,
    deleteAddress: _addresses.deleteAddress
}), _dec(_class = _dec2(_class = function (_React$Component) {
    (0, _inherits3.default)(AddressList, _React$Component);

    function AddressList(props) {
        (0, _classCallCheck3.default)(this, AddressList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressList.__proto__ || (0, _getPrototypeOf2.default)(AddressList)).call(this, props));

        _this.handleSetNewMode = function (value) {
            _this.setState({ isNewMode: value });
        };

        _this.handleUpdateAddress = function (id, value, is_default) {
            _this.props.updateAddress(id, value, is_default).then(function () {
                return _reactSAlert2.default.success(_this.props.lang['store.common.addresses.updated'], { position: 'top-right', effect: 'slide', timeout: 5000 });
            });;
        };

        _this.handleDeleteAddress = function (id) {
            _this.props.deleteAddress(id).then(function () {
                return _reactSAlert2.default.success(_this.props.lang['store.common.addresses.deleted'], { position: 'top-right', effect: 'slide', timeout: 5000 });
            });;
        };

        _this.sortAddresses = function (addresses) {
            var defaultIdx = addresses.findIndex(function (address) {
                return address.is_default;
            });
            if (defaultIdx < 0) return addresses.sort(function (a, b) {
                return b.id - a.id;
            });
            var defaultAddress = (0, _extends3.default)({}, addresses[defaultIdx]);
            addresses.splice(defaultIdx, 1);
            addresses.sort(function (a, b) {
                return b.id - a.id;
            });
            addresses.unshift(defaultAddress);
            return addresses;
        };

        _this.handleAddressAdd = _this.handleAddressAdd.bind(_this);

        if (!(typeof _this.handleAddressAdd === 'function')) {
            throw new TypeError('Value of "this.handleAddressAdd" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.handleAddressAdd));
        }

        _this.state = {
            isNewMode: false
        };
        return _this;
    }

    (0, _createClass3.default)(AddressList, [{
        key: 'handleAddressAdd',
        value: function handleAddressAdd(address) {
            var _this2 = this;

            this.props.addAddress(address).then(function () {
                _reactSAlert2.default.success(_this2.props.lang['store.common.addresses.added'], { position: 'top-right', effect: 'slide', timeout: 5000 });
                _this2.setState({ isNewMode: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                addresses = _props.addresses,
                lang = _props.lang;
            var isNewMode = this.state.isNewMode;

            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'h2',
                    { className: 'section-title' },
                    lang['store.common.addresses.title']
                ),
                this.sortAddresses(addresses).map(function (address) {
                    return _react3.default.createElement(_AddressListInput2.default, {
                        key: address.id,
                        handleUpdateAddress: _this3.handleUpdateAddress,
                        handleDeleteAddress: _this3.handleDeleteAddress,
                        id: address.id,
                        value: address.address,
                        is_default: address.is_default
                    });
                }),
                isNewMode ? _react3.default.createElement(_AddressListInput2.default, {
                    disableNewMode: function disableNewMode() {
                        return _this3.handleSetNewMode(false);
                    },
                    isNew: true, handleAddressAdd: this.handleAddressAdd
                }) : addresses.length < 5 && _react3.default.createElement(
                    'button',
                    { onClick: function onClick() {
                            return _this3.handleSetNewMode(true);
                        }, className: 'le-button pay_order_button' },
                    lang['store.common.addresses.add']
                )
            );
        }
    }]);
    return AddressList;
}(_react3.default.Component)) || _class) || _class));

exports.default = AddressList;

function _inspect(input, depth) {
    var maxDepth = 4;
    var maxKeys = 15;

    if (depth === undefined) {
        depth = 0;
    }

    depth += 1;

    if (input === null) {
        return 'null';
    } else if (input === undefined) {
        return 'void';
    } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
        return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
    } else if (Array.isArray(input)) {
        if (input.length > 0) {
            if (depth > maxDepth) return '[...]';

            var first = _inspect(input[0], depth);

            if (input.every(function (item) {
                return _inspect(item, depth) === first;
            })) {
                return first.trim() + '[]';
            } else {
                return '[' + input.slice(0, maxKeys).map(function (item) {
                    return _inspect(item, depth);
                }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
            }
        } else {
            return 'Array';
        }
    } else {
        var keys = (0, _keys2.default)(input);

        if (!keys.length) {
            if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
                return input.constructor.name;
            } else {
                return 'Object';
            }
        }

        if (depth > maxDepth) return '{...}';
        var indent = '  '.repeat(depth - 1);
        var entries = keys.slice(0, maxKeys).map(function (key) {
            return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
        }).join('\n  ' + indent);

        if (keys.length >= maxKeys) {
            entries += '\n  ' + indent + '...';
        }

        if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
            return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
        } else {
            return '{\n  ' + indent + entries + '\n' + indent + '}';
        }
    }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AddressList/index.js
// module id = 1796
// module chunks = 0